import { Component, Inject, Input, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ThemeService } from '../services/themes.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { ApiService } from '../services/api.service';
import { environment } from 'src/environments/environment';
import { TEMPLATE_NAMES } from '../constants';

@Component({
    selector: 'app-cookie-settings',
    templateUrl: './cookie-settings.component.html',
    styleUrls: ['./cookie-settings.component.scss']
})
export class CookieSettingsComponent implements OnInit {

    themedata: any;
    fontData: any;
    selectedRegion: any;
    cookieConsentData: any;
    cookieConsentDescription: string = `Below information provides details about how <strong>VMANICO</strong> Technologies Private Limited and its affiliates (“we”/”us”/”our”) use cookies, web-beacons and similar technologies on our website and mobile application. Cookies may be placed and used on some parts of our website and mobile applications. A cookie is small text file containing small amounts of information which is downloaded to your computer or mobile device that assist us in providing a more customised website experience. Cookies managed by us are referred to as “first party cookies” whereas cookies from third parties are referred to as “third party cookies”. <br>
        Cookies help us in improving your browsing experience by storing your preferences, ensuring the content matches with your expectations and negating the need to re-enter user data again in the next visit. Furthermore, cookies aid in analysing the utilization of our websites and online content (analytics cookies) and can also streamline/monitor interactions on our websites and online content with social media (such as links to social media platforms, like buttons, etc.). <br>
        Cookies are primarily employed to enrich the online experience of visitors and are not utilized to monitor the browsing behaviours of identified visitors unless we receive explicit and prior written consent from the visitor. Should a visitor have concerns regarding cookies, we allow individuals to reject them. Typically, a visitor can decline a cookie and still navigate our websites fully; however, certain site functionalities may be affected. <br>
        You can choose your desired cookie settings through our consent manager and in case you wish to remove undesired cookies from your websites, you can do this using the options available in your browser settings. Please bear in mind that deleting and blocking cookies affects your user experience.`;
    isNecessaryCookiesAllowed!: boolean;
    isPreferencedCookiesAllowed!: boolean;
    isMarketingCookiesAllowed!: boolean;
    isAnalyticalCookiesAllowed!: boolean;
    isOtherCookiesAllowed!: boolean;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<CookieSettingsComponent>,
        private router: Router,
        private cookieService: CookieService,
        private themeService: ThemeService,
        private spinnerService: NgxSpinnerService,
        private apiService: ApiService,
    ) {
        this.isNecessaryCookiesAllowed = data.isNecessaryCookiesAllowed;
        this.isPreferencedCookiesAllowed = data.isPerformanceCookiesAllowed;
        this.isMarketingCookiesAllowed = data.isMarketingCookiesAllowed;
        this.isAnalyticalCookiesAllowed = data.isAnalyticalCookiesAllowed;
        this.isOtherCookiesAllowed = data.isFunctionalCookiesAllowed;
    }

    ngOnInit(): void {
        this.themeService.theme$.subscribe((response) => {
            this.themedata = response;
        });

        this.themeService.selectedFont$.subscribe((response) => {
            this.fontData = response;
        });

        this.themeService.selectedRegion$.subscribe((response: any) => {
            this.selectedRegion = response;
            this.loadCookieSettingsPageData();
        });
    }

    loadCookieSettingsPageData() {
        if (environment.LOAD_LOCAL_DATA) {
            this.apiService.getCookieSettingsDataFromJSONFile().subscribe((response: any) => {
                this.cookieConsentData = response[`${TEMPLATE_NAMES.COOKIE_SETTINGS}-CONSENT-${this.selectedRegion}`];
            });
        }
    }

    allowAllCookies() {
        this.dialogRef.close('allowAll');
    }

    allowSelectedCookies() {
        this.dialogRef.close({
            result: 'allowSelected',
            necessaryCookies: this.isNecessaryCookiesAllowed || false,
            performanceCookies: this.isPreferencedCookiesAllowed || false,
            marketingCookies: this.isMarketingCookiesAllowed || false,
            analyticalCookies: this.isAnalyticalCookiesAllowed || false,
            functionalCookies: this.isOtherCookiesAllowed || false,
        });
    }

    denyAllCookies() {
        this.dialogRef.close('denyAll');
    }

    openHelpPage() {
        this.router.navigate(['/', 'contact-us']);
        this.dialogRef.close();
    }

    saveCookieConsent() {
        const cookieConsent = {
            necessaryCookies: this.isNecessaryCookiesAllowed || false,
            performanceCookies: this.isPreferencedCookiesAllowed || false,
            marketingCookies: this.isMarketingCookiesAllowed || false,
            analyticalCookies: this.isAnalyticalCookiesAllowed || false,
            functionalCookies: this.isOtherCookiesAllowed || false,
        };

        this.dialogRef.close(cookieConsent);
    }

    onClose() {
        this.dialogRef.close();
    }
}
